import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService} from 'ngx-webstorage-service';
import {CookieService} from 'ngx-cookie-service';
import {Utilities} from "../utils/utilities";

@Injectable({
    providedIn: 'root'
})
export class MyStorageService {

    constructor(@Inject(LOCAL_STORAGE) private storage: StorageService, private cookieService: CookieService) {
    }

    saveToCookies(key:string, object:any) {
        const expireDate = Utilities.addHoursToDate(new Date(), 24);
        this.cookieService.set(key, object, {expires: expireDate});
    }

    getFromCookies(key:string, fallbackObject:any) {
        const result = this.cookieService.get(key);
        return (result.length>0? result : fallbackObject);
    }
  getFromCookiesWithParse(key:string, fallbackObject:any) {
    const result = this.cookieService.get(key);
    return (result.length>0? JSON.parse(result) : fallbackObject);
  }

    deleteFromCookies(key:string) {
        this.cookieService.delete(key);
    }

    saveToStore(key:string, object:any) {
        this.storage.set(key, object)
    }

    getFromStore<T>(key:string, fallbackObject:T):T {
        return this.storage.has(key) ? this.storage.get(key) : fallbackObject;
    }

    deleteFromStore(key:string) {
        this.storage.remove(key);
    }

    checkKey(key: string){
        return this.cookieService.check(key);
    }
}
